"use strict";
require.context("../images", true);
import HorizontalMenuController from "./src/controllers/horizontal_menu_controller";
window.Stimulus.register("horizontal-menu", HorizontalMenuController);
